export function createChainedObserver({
      elements,
      threshold = 0.2,
      onIntersect
  }) {
    let chain = Promise.resolve();

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const index = elements.indexOf(entry.target);

            chain = chain.then(() => {
                return Promise.resolve(
                    onIntersect({
                        entry,
                        index,
                        elements
                    })
                );
            });
        });
    }, {threshold});

    elements.forEach(el => observer.observe(el));

    return observer;
}